import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import Link from 'next/link'
import { cn } from '@/lib/utils'
import { siteConfig } from '@/constants/site'

interface LogoProps {
    className?: string
    showTagline?: boolean
}

export const Logo: FC<LogoProps> = ({ className, showTagline = true }): ReactNode => {
    return (
        <Link
            href='/'
            aria-label={`${siteConfig.name} home`}
            className={cn('focus-ring group inline-flex items-center gap-3 rounded-full', className)}
        >
            <span className='relative block size-11 shrink-0 overflow-hidden rounded-full ring-1 ring-gold/40 transition-transform duration-500 group-hover:rotate-12'>
                <Image
                    src='/images/logo.png'
                    alt=''
                    width={1024}
                    height={1024}
                    sizes='44px'
                    className='size-full object-cover'
                />
            </span>

            <span className='flex flex-col leading-none'>
                <span className='text-lg font-extrabold tracking-[0.18em] text-white uppercase'>
                    <span className='text-crimson-bright'>Guju</span>
                    {' '}
                    Events
                </span>

                {showTagline && (
                    <span className='mt-1 text-[0.62rem] font-semibold tracking-[0.28em] text-white/55 uppercase'>
                        {siteConfig.tagline}
                    </span>
                )}
            </span>
        </Link>
    )
}
